import parseXml from './parseXml.js';

export default function parseFollowUpSuggestions(text) {
  const raw = parseXml('follow_up_suggestions', text);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw);
    if (Array.isArray(parsed) && parsed.every((s) => s.title && s.message)) return parsed;
  } catch { /* ignore parse errors */ }
  return null;
}
